import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { useStoreState } from 'easy-peasy';
import { useContext } from 'react';
import { useQuery } from 'react-query';

import { getCaseDamages } from '@ge/feat-monitor/services';
import { ReportsContext } from '@ge/feat-reporting/context/reports-context';
import { useReportScope } from '@ge/feat-reporting/hooks/use-report-scope';
import { QueryKey } from '@ge/models/constants';

dayjs.extend(isoWeek);

export const useWidgetDamages = ({ endDate: _endDate, startDate: _startDate, isActive = true }) => {
  const getAssetById = useStoreState((state) => state.assets.getAssetById);
  const getSiteById = useStoreState((state) => state.sites.getSiteById);
  const { toggleDateRange } = useContext(ReportsContext);
  const { siteIds } = useReportScope();
  let startDate = new Date(_startDate);
  let endDate = new Date(_endDate);
  endDate.setHours(23, 59, 59, 999);

  const params = {
    siteIds: siteIds?.join(','),
    components: 'Main Bearing,Gearbox,Generator,Pitch Bearing',
    status: 'Open',
    startDate: toggleDateRange ? Math.floor(startDate.getTime() / 1000) : null,
    endDate: toggleDateRange ? Math.floor(endDate.getTime() / 1000) : null,
  };

  const {
    data: data,
    error,
    isLoading,
  } = useQuery([QueryKey.CASE_DAMAGES, params], () => getCaseDamages(params), {
    enabled: Boolean(isActive),
  });

  let accumulatedDatas = [];

  if (Array.isArray(data) && data.length > 0) {
    data.forEach((damage) => {
      if (damage !== '' && damage !== null) {
        const asset = getAssetById(damage.asset_id);
        const site = getSiteById(asset?.site?.id);

        const completeData = {
          ...damage,
          siteId: site?.id || '',
          site: site?.name || '',
          asset: asset?.name || '',
          model: asset?.model || '',
          indicationDate: (damage?.indicationDate || 0) * 1000,
          serialNumber: asset?.serialNumber || '',
        };

        accumulatedDatas.push(completeData);
      }
    });
  }

  accumulatedDatas.sort((a, b) => {
    if (a.siteId === b.siteId) {
      return a.asset.localeCompare(b.asset);
    }
    return a.site.localeCompare(b.site);
  });

  return { data: accumulatedDatas?.length ? accumulatedDatas : [], error, isLoading };
};
